import {
  ElementRef,
  Injectable,
  Renderer2,
  ViewContainerRef
} from '@angular/core';
import { ErrorMessageComponent } from '../../../components/molecules/error-message/error-message.component';
import { ErrorMessage } from '../../../components/molecules/error-message/models/error-message.interfaces';
import { Shape } from '../../../components/molecules/skeleton-loader/models/skeleton-loader.interface';
import { SkeletonLoaderComponent } from '../../../components/molecules/skeleton-loader/skeleton-loader.component';

@Injectable({
  providedIn: 'root'
})
export class SkeletonLoaderService {
  checkForLoading(loaded: boolean, disabled: boolean) {
    return loaded && disabled;
  }

  addLoader(
    element: ElementRef,
    renderer: Renderer2,
    viewContainerRef: ViewContainerRef,
    shape: Shape
  ) {
    [...element.nativeElement.children].forEach((el: HTMLElement) => {
      renderer.setStyle(el, 'display', 'none');
    });
    const componentRef = viewContainerRef.createComponent(
      SkeletonLoaderComponent
    );
    componentRef.instance.shape =
      Object.keys(shape).length !== 0
        ? shape
        : {
            verticalRectangle: {
              display: true,
              count: 3
            }
          };
    element.nativeElement.insertBefore(
      componentRef.location.nativeElement,
      element.nativeElement.firstChild
    );
  }

  removeLoader(element: ElementRef, renderer: Renderer2, removeEl?: boolean) {
    if (removeEl) {
      element.nativeElement.remove();
    } else {
      [...element.nativeElement.children].forEach(
        (el: HTMLElement, index: number) => {
          if (index !== 0) {
            renderer.setStyle(el, 'display', '');
          }
        }
      );
      const skeletonLoaderElement = element.nativeElement.getElementsByTagName(
        'idp-skeleton-loader'
      )[0];
      skeletonLoaderElement && skeletonLoaderElement.remove();
    }
  }

  checkForError(
    loaded: boolean,
    disabled: boolean,
    error: ErrorMessage | undefined
  ) {
    return loaded && disabled && error;
  }

  addError(
    error: ErrorMessage,
    element: ElementRef,
    viewContainerRef: ViewContainerRef
  ) {
    if (
      element.nativeElement.children.length === 0 ||
      element.nativeElement.children[0].tagName !== 'IDP-ERROR-MESSAGE'
    ) {
      [...element.nativeElement.children].forEach((el: HTMLElement) => {
        el.remove();
      });
      const componentRef = viewContainerRef.createComponent(
        ErrorMessageComponent
      );
      componentRef.instance.content = error;
      element.nativeElement.appendChild(componentRef.location.nativeElement);
    }
  }
}
